export class Badge {
    image: string|undefined;
    image_width: number|undefined;
    image_height: number|undefined;
    image_mobile: string|undefined;
    image_mobile_width: number|undefined;
    image_mobile_height: number|undefined;
    title: string;
    description: string;
    url: string;
  
    constructor(title: string, description: string, url: string) {
      this.title = title;
      this.description = description;
      this.url = url;
    }

    addImage(image: string, width: number, height: number) {
      this.image = image;
      this.image_width = width;
      this.image_height = height; 
    }

    addMobileImage(image_mobile: string, width: number, height: number) {
      this.image_mobile = image_mobile;
      this.image_mobile_width = width;
      this.image_mobile_height = height;
    }
  }
  